'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _constants = require('../../constants');
var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _HolomaxPage = require('./HolomaxPage.scss');var styles = _interopRequireWildcard(_HolomaxPage);

var _config = require('./config');
var _messageModal = require('../../redux/modules/messageModal');
var _VRPhotoInvoiceModal = require('../../containers/DetailsToInvoiceVRPhoto/VRPhotoInvoiceModal');var _VRPhotoInvoiceModal2 = _interopRequireDefault(_VRPhotoInvoiceModal);
var _userAuthentication = require('../../redux/modules/userAuthentication');





var _payments = require('../../redux/modules/payments');






var _components = require('../../components');
var _notifications = require('../../redux/modules/notifications');
var _paymentCalculation = require('../../helpers/paymentCalculation');
var _WhatsAppWidget = require('../../components/WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /* eslint-disable jsx-a11y/media-has-caption */

_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);var

HolomaxPage = function (_Component) {_inherits(HolomaxPage, _Component);function HolomaxPage() {var _temp, _this, _ret;_classCallCheck(this, HolomaxPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showModal: false,
      selectedPackageData: null,
      showProcessOverlay: false,
      invoiceData: null }, _this.







































































    setVideoContainerSize = function () {
      _this.backgroundContainer.style.height = window.innerHeight + 'px';
    }, _this.

    closeDetailsModal = function () {return _this.setState({ showModal: false });}, _this.

    showOverlay = function () {return _this.setState({ showProcessOverlay: true });}, _this.

    openDetailsToInvoiceForm = function (selectedPackageData) {
      _this.setState({
        showModal: true,
        selectedPackageData: selectedPackageData,
        invoiceData: null,
        isPaymentOpen: true,
        isIframeOpen: true });

    }, _this.

    hideIframeModal = function () {
      _this.setState({ isIframeOpen: false });
      _this.props.hideMessageModal();
    }, _this.

    saveInvoiceData = function (invoiceData) {return _this.setState({ invoiceData: invoiceData });}, _this.

    handlePurchase = function (isSuccessPaid, isRequestFailed, transactionId) {
      if (isSuccessPaid) {
        _this.setState({ isPaymentOpen: false, showProcessOverlay: true });
        return _this.props.verifyPayment({
          data: {
            user_id: _this.props.userAuthentication.data.id,
            locale: _this.props.locale,
            admin: false,
            transactionId: transactionId },

          token: _this.props.userToken });

      } else if (isRequestFailed) {
        _this.setState({ isPaymentOpen: false, showProcessOverlay: true });
        return Promise.
        resolve(_this.props.inquirePayment({
          data: {
            user_id: _this.props.userAuthentication.data.id,
            locale: _this.props.locale,
            admin: false,
            transactionId: transactionId },

          token: _this.props.userToken })).

        then(function () {
          _this.setState({ showProcessOverlay: false });
          _this.props.openMessageModal({
            message:
            _react2.default.createElement(_components.PaymentFailMessage, {
              closeModal: _this.props.hideMessageModal,
              translate: _this.props.purchaseTranslate('FailModal') }),


            isCloseButtonInvisible: true,
            className: 'failPaymentModal' });

        });
      }
      window.hideMessageModal = null;
      window.successPayment = null;
      window.failPayment = null;
      window.isDesktop = null;
      return null;
    }, _this.

    scrollToPackages = function () {return _reactScroll.scroller.scrollTo('packagesBlock', {
        offset: _this.props.isMobile ? -60 : -80,
        duration: 500,
        smooth: true });}, _this.


    renderOrderButton = function (className) {return (
        _react2.default.createElement('button', { className: (0, _classnames2.default)(styles.orderButton, className), onClick: _this.scrollToPackages },
          _react2.default.createElement('span', null, _this.props.translate('toOrder')), '\xA0\xA0',
          _react2.default.createElement('span', { className: 'icon icon-prev' })));}, _this.



    renderHeadContent = function () {return (
        _react2.default.createElement('div', { className: styles.headContent },
          _react2.default.createElement('div', { className: styles.logo }, _react2.default.createElement('img', { src: _config.iconLinks.holoLogoFull, alt: '' })),
          _react2.default.createElement('h1', null, _this.props.translate('headTitle')),
          _react2.default.createElement('h2', null, _this.props.translate('headSubtitle')),
          _react2.default.createElement('div', { className: styles.buttonLine },
            _react2.default.createElement('img', { className: styles.arrow, src: _config.iconLinks.arrow, alt: '' }),
            _this.renderOrderButton(styles.headButton))));}, _this.




    renderAbout = function () {return (
        _react2.default.createElement('div', { className: styles.about },
          _react2.default.createElement('div', { className: styles.aboutContent },
            _react2.default.createElement('h2', null, _this.props.translate('aboutTitle')),
            _react2.default.createElement('h3', null, _this.props.translate('aboutSubtitle')),
            _react2.default.createElement('div', null, _this.props.translate('aboutDescription')),
            _this.renderOrderButton()),

          !_this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.video },
            _react2.default.createElement('img', { src: _config.iconLinks.laptop, alt: '' }),
            _react2.default.createElement('div', null,
              _react2.default.createElement('video', {
                  autoPlay: true,
                  muted: true,
                  loop: true,
                  height: 260 },

                _react2.default.createElement('source', { src: _config.iconLinks.video + '.mp4', type: 'video/mp4' }),
                _react2.default.createElement('source', { src: _config.iconLinks.video + '.ogv', type: 'video/ogv' }),
                _react2.default.createElement('source', { src: _config.iconLinks.video + '.webm', type: 'video/webm' }))))));}, _this.







    renderBenefit = function (_ref) {var icon = _ref.icon,description = _ref.description,title = _ref.title;return (
        _react2.default.createElement('div', { className: styles.benefit, key: title },
          _react2.default.createElement('img', { src: icon, alt: '' }),
          _react2.default.createElement('div', null, _this.props.translate(description))));}, _this.



    renderBenefits = function () {return (
        _react2.default.createElement('div', { className: styles.benefits },
          _react2.default.createElement('h2', { className: styles.title },
            _react2.default.createElement('span', null,
              _react2.default.createElement('span', null, _this.props.translate('benefitsTitle')),
              _react2.default.createElement('img', { src: _config.iconLinks.underline, alt: '' }))),


          _react2.default.createElement('div', { className: styles.benefitsWrapper },
            _config.benefits.map(_this.renderBenefit))));}, _this.




    renderProfit = function () {return (
        _react2.default.createElement('div', { className: styles.profit },
          _react2.default.createElement('div', null,
            _react2.default.createElement('h2', { className: styles.title },
              _react2.default.createElement('span', null,
                _react2.default.createElement('span', null, _this.props.translate('profitTitle')),
                _react2.default.createElement('img', { src: _config.iconLinks.underline, alt: '' }))),


            _react2.default.createElement('div', { className: styles.profitItem },
              _react2.default.createElement('img', { src: _config.iconLinks.check, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('profit1'))),

            _react2.default.createElement('div', { className: styles.profitItem },
              _react2.default.createElement('img', { src: _config.iconLinks.check, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('profit2'))),

            _react2.default.createElement('div', { className: styles.profitItem },
              _react2.default.createElement('img', { src: _config.iconLinks.check, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('profit3')))),


          _react2.default.createElement('div', { className: styles.profitImage },
            _react2.default.createElement('img', { src: _config.iconLinks.people, alt: '' }))));}, _this.




    renderHowItWorks = function () {return (
        _react2.default.createElement('div', { className: styles.howItWorks },
          _react2.default.createElement('div', { className: styles.howItWorksContent },
            _react2.default.createElement('h2', { className: styles.title },
              _react2.default.createElement('span', null,
                _react2.default.createElement('span', null, _this.props.translate('howItWorksTitle')),
                _react2.default.createElement('img', { src: _config.iconLinks.underline, alt: '' }))),


            _react2.default.createElement('div', { className: styles.howItWorksItem },
              _react2.default.createElement('img', { src: _config.iconLinks.check, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('howItWorks1'))),

            _react2.default.createElement('div', { className: styles.howItWorksItem },
              _react2.default.createElement('img', { src: _config.iconLinks.check, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('howItWorks2'))),

            _react2.default.createElement('div', { className: styles.howItWorksItem },
              _react2.default.createElement('img', { src: _config.iconLinks.check, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('howItWorks3'))),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.howItWorksItem, styles.markedItem) },
              _react2.default.createElement('img', { src: _this.props.isMobile ? _config.iconLinks.starBig : _config.iconLinks.star, alt: '' }), '\xA0\xA0\xA0',
              _react2.default.createElement('span', null, _this.props.translate('howItWorks4')))),


          _react2.default.createElement('div', { className: styles.howItWorksImage },
            _react2.default.createElement('img', { src: _config.iconLinks.house, alt: '' }))));}, _this.




    renderPackage = function (_ref2) {var _cx;var id = _ref2.id,oldPrice = _ref2.oldPrice,price = _ref2.price,rest = _objectWithoutProperties(_ref2, ['id', 'oldPrice', 'price']);return (
        _react2.default.createElement('div', {
            key: id,
            style: {
              backgroundImage: 'url(' + _config.iconLinks.clouds + ')',
              backgroundColor: '#fff' } },


          _react2.default.createElement('div', { className: (0, _classnames2.default)((_cx = {}, _cx[styles.paddedImage] = id === 2, _cx)) },
            _react2.default.createElement('img', { src: _config.iconLinks['house' + id], alt: '' })),

          _react2.default.createElement('div', { className: styles.packageName }, _this.props.translate('packageName' + id)),
          oldPrice &&
          _react2.default.createElement('div', { className: styles.packageOldPrice },
            _react2.default.createElement('span', null, oldPrice), '\xA0', _react2.default.createElement('span', null, '\u20AA'),
            _react2.default.createElement('div', { className: styles.priceLine })),


          _react2.default.createElement('div', { className: styles.packagePrice },
            _react2.default.createElement('span', null, price), '\xA0', _react2.default.createElement('span', null, '\u20AA')),

          _react2.default.createElement('button', { onClick: function onClick() {return _this.openDetailsToInvoiceForm(Object.assign({ id: id, oldPrice: oldPrice, price: price }, rest));} },
            _this.props.translate('toOrder'))));}, _this.




    renderMobilePackage = function (_ref3) {var id = _ref3.id,oldPrice = _ref3.oldPrice,price = _ref3.price,rest = _objectWithoutProperties(_ref3, ['id', 'oldPrice', 'price']);return (
        _react2.default.createElement('div', { key: id, onClick: function onClick() {return _this.openDetailsToInvoiceForm(Object.assign({ id: id, oldPrice: oldPrice, price: price }, rest));} },
          _react2.default.createElement('div', { className: styles.nameLine },
            _react2.default.createElement('div', { className: styles.packageImage },
              _react2.default.createElement('img', { src: _config.iconLinks['house' + id + 'Mob'], alt: '' })),


            _react2.default.createElement('div', { className: styles.packageName }, _this.props.translate('packageName' + id))),


          _react2.default.createElement('div', { className: styles.packagePriceLine },
            oldPrice &&
            _react2.default.createElement('div', { className: styles.packageOldPrice },
              _react2.default.createElement('span', null, oldPrice), '\xA0', _react2.default.createElement('span', null, '\u20AA'),
              _react2.default.createElement('div', { className: styles.priceLine })),


            _react2.default.createElement('div', { className: styles.packagePrice },
              _react2.default.createElement('span', null, price), '\xA0', _react2.default.createElement('span', null, '\u20AA'))),



          _react2.default.createElement('div', { className: styles.mobileOrderButton },
            _react2.default.createElement('div', null,
              _react2.default.createElement('span', null, _this.props.translate('toOrder')), '\xA0\xA0',
              _react2.default.createElement('span', { className: 'icon icon-prev' })))));}, _this.





    renderPackages = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: 'packagesBlock', className: styles.packagesBlock },
          _react2.default.createElement('h2', null, _this.props.translate('packagesTitle')),
          _react2.default.createElement('h3', null, _this.props.translate('packagesSubtitle')),
          _react2.default.createElement('div', { className: _this.props.isMobile ? styles.mobilePackages : styles.packages },
            _config.packages.map(_this.props.isMobile ? _this.renderMobilePackage : _this.renderPackage))));}, _temp), _possibleConstructorReturn(_this, _ret);}HolomaxPage.prototype.componentDidMount = function componentDidMount() {this.setVideoContainerSize();if (!this.props.isMobile) {window.addEventListener('resize', this.setVideoContainerSize);}};HolomaxPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref4) {var _this2 = this;var payments = _ref4.payments,isMessageModalOpen = _ref4.isMessageModalOpen;if (payments.sent && this.props.payments.sent !== payments.sent) {this.closeDetailsModal();}if (this.props.payments.redirectUrl !== payments.redirectUrl) {this.props.openMessageModal({ message: _react2.default.createElement('iframe', { id: 'payment-iframe', src: payments.redirectUrl, title: 'payments' }, _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })), className: 'invoiceModal', shouldCloseOnOverlayClick: false });this.setState({ isPaymentOpen: true, isIframeOpen: true });}if (this.state.isPaymentOpen && !this.state.isIframeOpen && !isMessageModalOpen && this.props.isMessageModalOpen) {var isSuccessPaid = payments.isSuccessPaid,isRequestFailed = payments.isRequestFailed,transactionId = payments.transactionId;this.handlePurchase(isSuccessPaid, isRequestFailed, transactionId);}if (payments.isSuccessVerified && !this.props.payments.isSuccessVerified) {var email = (0, _get2.default)(this.props, 'userAuthentication.data.email');var _ref5 = this.state.invoiceData || {},name = _ref5.invoice_name,phone_number = _ref5.phone_number;var _ref6 = this.state.selectedPackageData || {},count = _ref6.count,price = _ref6.price;var postfix = count > 1 ? 's' : '';var translate = this.props.purchaseTranslate('PurchaseSummery');var amount = (0, _paymentCalculation.calculatePriceWithVAT)(price);var summary = translate('advertisingForVR') + ' ' + count + ' ' + translate('photo' + postfix) + '\n' + translate('totalInclude') + amount + '\u20AA';this.props.sendVRPaymentNotification({ name: name, email: email, phone_number: phone_number, summary: summary }).then(function () {_this2.setState({ showProcessOverlay: false });_this2.props.resetPaymentData();_this2.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage successMessage' }, _react2.default.createElement('p', null, _this2.props.translate('payedSuccessful'))), shouldCloseOnOverlayClick: false });});}};HolomaxPage.prototype.componentWillUnmount = function componentWillUnmount() {if (!this.props.isMobile) {window.removeEventListener('resize', this.setVideoContainerSize);}};HolomaxPage.prototype.




  render = function render() {var _this3 = this;var _props =
    this.props,translate = _props.translate,rootTranslate = _props.rootTranslate,route = _props.route,locale = _props.locale,isMobile = _props.isMobile;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);
    return (
      _react2.default.createElement('div', {
          className: styles.pageContainer },

        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: rootTranslate('title', 'titleTemplate')(),
          title: translate('headTitle')(),
          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route },
          { property: 'og:title', content: translate('headTitle')() + ' | \u202BOnMap' },
          { property: 'og:description', content: translate('headSubtitle') },
          { name: 'description', content: translate('headSubtitle') }],

          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),


        _react2.default.createElement('div', {
            className: styles.pageWrapper },

          _react2.default.createElement('div', { className: styles.masthead },
            _react2.default.createElement('div', {
                className: (0, _classnames2.default)(styles.backgroundBlock, 'limitedHeight'),
                ref: function ref(backgroundContainer) {_this3.backgroundContainer = backgroundContainer;} },

              _react2.default.createElement('div', {
                className: styles.imgCover,
                style: {
                  backgroundImage: 'url(' + _config.iconLinks.headImage + ')' } }),


              _react2.default.createElement('img', { className: styles.imgOverlay, src: _config.iconLinks[isMobile ? 'headMobileOverlay' : 'headOverlay'], alt: '' }),
              !isMobile && _react2.default.createElement('img', { className: styles.imgLogo, src: this.props.isRtl ? _config.iconLinks.gswLogoRtl : _config.iconLinks.gswLogo, alt: '' }))),



          this.renderHeadContent()),


        _react2.default.createElement('div', {
            style: {
              backgroundImage: 'url(' + _config.iconLinks.background + ')',
              backgroundSize: isMobile ? 'auto' : 'cover',
              backgroundPosition: '50% 10%' } },


          this.renderAbout(),

          this.renderBenefits(),

          this.renderProfit(),

          this.renderHowItWorks(),

          this.renderPackages(),

          _react2.default.createElement('h4', { className: styles.vatMessage }, '*\xA0', this.props.translate('vatMessage'), '\xA0*')),


        _react2.default.createElement(_VRPhotoInvoiceModal2.default, {
          isOpen: this.state.showModal,
          isRtl: this.props.isRtl,
          translate: this.props.rootTranslate,
          isMobile: this.props.isMobile,
          close: function close() {return _this3.setState({ showModal: false });},
          socialNetworkAuthentication: this.props.socialNetworkAuthentication,
          userToken: this.props.userToken,
          isLoggedIn: !!this.props.userToken,
          auth: this.props.authenticateUser,
          editUserProfile: this.props.editUserProfile,
          sendPaymentRequest: this.props.sendPaymentRequest,
          userAuthentication: this.props.userAuthentication,
          logOut: this.props.logOut,
          openAuthenticationModal: this.props.openAuthenticationModal,
          locale: this.props.locale,
          openMessageModal: this.props.openMessageModal,
          hideMessageModal: this.props.hideMessageModal,
          payments: this.props.payments,
          selectedPackageData: this.state.selectedPackageData,
          successPayment: this.props.successPayment,
          failPayment: this.props.failPayment,
          hideIframeModal: this.hideIframeModal,
          saveInvoiceData: this.saveInvoiceData }),

        _react2.default.createElement(_components.PublishProcessOverlay, {
          translate: this.props.rootTranslate('publishProperty'),
          isOpen: this.state.showProcessOverlay }),

        _react2.default.createElement(_WhatsAppWidget2.default, { translate: this.props.rootTranslate })));


  };return HolomaxPage;}(_react.Component);


HolomaxPage.propTypes = {
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  purchaseTranslate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  userAuthentication: _propTypes2.default.object,
  payments: _propTypes2.default.object,
  socialNetworkAuthentication: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  successPayment: _propTypes2.default.func,
  failPayment: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  logOut: _propTypes2.default.func,
  verifyPayment: _propTypes2.default.func,
  inquirePayment: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  sendPaymentRequest: _propTypes2.default.func,
  resetPaymentData: _propTypes2.default.func,
  sendVRPaymentNotification: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  route: _propTypes2.default.any };



var mapStateToProps = function mapStateToProps(state) {return {
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    purchaseTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty'),
    translate: (0, _reduxPagan.getLang)(state.lang, 'VRPromotion'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userAuthentication: state.userAuthentication,
    userToken: state.userAuthentication.data ?
    state.userAuthentication.data.access_token :
    null,
    payments: state.payments,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  socialNetworkAuthentication: _userAuthentication.socialNetworkAuthentication,
  authenticateUser: _userAuthentication.authenticateUser,
  editUserProfile: _userAuthentication.editUserProfile,
  sendPaymentRequest: _payments.sendPaymentRequest,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  successPayment: _payments.successPayment,
  failPayment: _payments.failPayment,
  verifyPayment: _payments.verifyPayment,
  inquirePayment: _payments.inquirePayment,
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  sendVRPaymentNotification: _notifications.sendVRPaymentNotification,
  resetPaymentData: _payments.resetPaymentData })(

HolomaxPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/HolomaxPage/HolomaxPage.js
// module id = 3107
// module chunks = 0